import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { OfflineDownloadStatus } from "../constants";
import { timestamps } from "../utils/fields";

export const CollectionType = {
  PLAYLIST: "playlist",
  ALBUM: "album",
} as const;

export const offlineCollections = sqliteTable("offline_collections", {
  ...timestamps,
  collectionId: text("collection_id").primaryKey(),
  collectionType: text("collection_type", {
    enum: [CollectionType.PLAYLIST, CollectionType.ALBUM],
  }).notNull(),
  title: text("title").notNull(),
  status: text("status", {
    enum: [
      OfflineDownloadStatus.PENDING,
      OfflineDownloadStatus.DOWNLOADING,
      OfflineDownloadStatus.COMPLETED,
      OfflineDownloadStatus.FAILED,
      OfflineDownloadStatus.PAUSED,
      OfflineDownloadStatus.MARKED_FOR_DELETION,
      OfflineDownloadStatus.NEEDS_REDOWNLOAD,
    ],
  }).notNull(),
  totalTracks: integer("total_tracks").notNull(),
  downloadedTracks: integer("downloaded_tracks").notNull().default(0),
  trackIds: text("track_ids", { mode: "json" }).notNull().$type<string[]>(),
  rawData: text("raw_data", { mode: "json" }).notNull().$type<{
    [key: string]: unknown;
  }>(),
});

// Export types for use in your app
export type OfflineCollection = typeof offlineCollections.$inferSelect;
